// extracted by mini-css-extract-plugin
export default {"button":"ActionButton-module__button--fa74a"};